<template>
  <div class="h-100">
    <div class="content-page pr-3 pl-3 pt-2 pb-2 h-100">
      <b-row class="h-100">
        <b-col cols="4" class="mh-100">
          <div class="h-100 bg-white">
            <div class="row table2_header" style="margin: 0">
              <div class="col-sm-5 pt-0 pb-0 pr-0 pl-0"></div>
              <div class="col-sm-7 pt-0 pb-0 pr-0 pl-0 text-right">
                <font-awesome-icon
                  icon="plus"
                  style="cursor: pointer"
                  v-if="hasRight('AlwWrite')"
                  @click="initUser"
                />
              </div>
            </div>
            <div class="overflow-y-auto treeview-height">
              <v-treeview
                :items="LocationTree"
                item-key="LocCode"
                dense
                @update:active="getLocation"
              >
                <template v-slot:label="{ item }">
                  <div style="cursor: pointer" @click="getLocation(item)">
                    {{ item.LocDesc }}
                  </div>
                </template>
              </v-treeview>
            </div>
          </div>
        </b-col>
        <b-col cols="8">
          <div class="h-100 bg-white font-weight-bold">
            <div class="tab-pane active table-responsive color-table h-90">
              <div class="col-lg-12 pr-4 pl-4 pt-0 pb-0">
                <b-row cols="inputRow" class="pt-4">
                  <b-col sm="3">
                    <label>{{ t.t(dictEnum.LBL_LocCode) }}</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input
                      maxlength="15"
                      :disabled="mode != 'new'"
                      v-model="selectedLoc.LocCode"
                      size="sm"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row cols="inputRow" class="pt-4">
                  <b-col sm="3">
                    <label>{{ t.t(dictEnum.LBL_Description) }}</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input
                      maxlength="50"
                      v-model="selectedLoc.LocDesc"
                      size="sm"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row cols="inputRow" class="pt-4">
                  <b-col sm="3">
                    <label>{{ t.t(dictEnum.LBL_ParentLoc) }}</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select
                      v-model="selectedLoc.ParentLoc"
                      :options="ParentLocList"
                      value-field="LocCode"
                      size="sm"
                      text-field="LocDesc"
                    ></b-form-select>
                  </b-col>
                </b-row>
                <b-row cols="inputRow" class="pt-4">
                  <b-col sm="3">
                    <label>{{ t.t(dictEnum.LBL_Address) }}</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input
                      v-model="selectedLoc.Addr"
                      size="sm"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row cols="inputRow" class="pt-4">
                  <b-col sm="3">
                    <label>{{ t.t(dictEnum.LBL_District) }}</label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-select
                      v-model="selectedLoc.Country"
                      v-on:change="changeCountry"
                      :options="countryList"
                      value-field="Country"
                      size="sm"
                      :text-field="
                        user.Lang == 'EN' ? 'AreaDesc' : 'AreaChiDesc'
                      "
                    ></b-form-select>
                  </b-col>
                  <b-col sm="3"
                    ><b-form-select
                      v-model="selectedLoc.District"
                      v-on:change="changeDistrict"
                      :options="districtList"
                      value-field="District"
                      size="sm"
                      :text-field="
                        user.Lang == 'EN' ? 'AreaDesc' : 'AreaChiDesc'
                      "
                    ></b-form-select>
                  </b-col>
                  <b-col sm="3">
                    <b-form-select
                      v-model="selectedLoc.Area"
                      :options="areaList"
                      value-field="Area"
                      size="sm"
                      :text-field="
                        user.Lang == 'EN' ? 'AreaDesc' : 'AreaChiDesc'
                      "
                    ></b-form-select>
                  </b-col>
                </b-row>
                <b-row cols="inputRow" class="pt-4">
                  <b-col sm="3">
                    <label>{{ t.t(dictEnum.LBL_NFCTag) }}</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input
                      v-model="selectedLoc.NFCTag"
                      size="sm"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </div>
            </div>

            <div class="h-10">
              <b-col sm="12" class="text-right">
                <button
                  v-if="
                    hasRight('AlwDel', Settings.MenuID.MM_Loc) && mode != 'new'
                  "
                  type="button"
                  class="btn btn-danger"
                  @click="deleteLocation"
                >
                  {{ this.t.t(dictEnum.BTN_Delete) }}
                </button>
                <button
                  v-if="
                    hasRight(Settings.Permission.Change, Settings.MenuID.MM_Loc)
                  "
                  type="button"
                  class="btn btn-info"
                  @click="saveLocation"
                >
                  {{ this.t.t(dictEnum.BTN_Save) }}
                </button>
              </b-col>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import StoreGetter from "@/constants/StoreGetter";
import { datePickerLang } from "@/constants/globalConstants";
import LocationService from "@/service/LocationService";
import { Location } from "@/model/Location";
import TreeNodeHelper from "@/common/helper/TreeNodeHelper";
import DistrictService from "@/service/DistrictService";
import SweetAlertService from "@/service/SweetAlertService";
import Settings from "../../constants/Settings";
export default {
  components: {
    DatePicker,
    moment,
  },
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    LocationTree() {
      let list = this.$data.locationList;
      const tree = TreeNodeHelper.flattenToTree(
        this.$data.locationList,
        "LocCode",
        "children",
        "ParentLoc"
      );
      return tree;
    },
    ParentLocList() {
      const list = this.$data.locationList;
      const tree = TreeNodeHelper.flattenToTree(
        this.$data.locationList,
        "LocCode",
        "children",
        "ParentLoc"
      );
      let locChildren = [];
      tree.forEach((item) => {
        if (item.LocCode == this.selectedLoc.LocCode) {
          locChildren = [...item.children];
          item.children.forEach((x) => {
            if (x.children.length != 0) {
              locChildren.push(...x.children);
            }
          });
        } else if (item.children.length != 0) {
          item.children.forEach((it) => {
            if (it.LocCode == this.selectedLoc.LocCode) {
              locChildren = [...it.children];
            }
          });
        }
      });
      locChildren = locChildren.map((item) => item.LocCode);
      return list.filter(
        (x) =>
          x.LocCode != this.selectedLoc.LocCode &&
          !locChildren.includes(x.LocCode)
      );
    },
    areaList() {
      const list = this.districts.filter(
        (obj) =>
          obj.District == this.selectedLoc.District &&
          obj.Area != "" &&
          obj.Area != "-"
      );
      return list;
    },
    districtList() {
      const list = this.districts.filter(
        (obj) =>
          obj.Country == this.selectedLoc.Country &&
          obj.Area == "" &&
          obj.District != "" &&
          obj.District != "-"
      );
      return list;
    },
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.MM_Loc,
      Settings: Settings,
      dictEnum: dictEnum,
      lang: datePickerLang,
      locationList: [],
      mode: "new",
      selectedLoc: new Location(),
      districts: [],
      countryList: [],
    };
  },

  methods: {
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        (x) => x.MenuID == this.menuId
      );
    },
    async getLocationList() {
      const response = await LocationService.getLocationList();
      if (response.data.IsSuccess) {
        this.locationList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getLocation(Location) {
      const obj = {
        LocCode: Location.LocCode,
      };
      const response = await LocationService.getLocation(obj);
      if (response.data.IsSuccess) {
        this.selectedLoc = response.data.Data;
        this.mode = "update";
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getDistrictList() {
      const obj = {};
      const response = await DistrictService.getDistrict(obj);
      if (response.data.IsSuccess) {
        this.districts = response.data.Data;
        const countryList = response.data.Data.filter(
          (obj) => obj.District == "" && obj.Area == ""
        );
        this.countryList = countryList;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    initUser() {
      this.selectedLoc = new Location();
      this.mode = "new";
    },

    changeCountry() {
      this.selectedLoc.District = "";
    },

    changeDistrict() {
      this.selectedLoc.Area = "";
    },

    async saveLocation() {
      if (!this.selectedLoc.LocCode) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_LocCode) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      //   if (!this.selectedLoc.LocDesc) {
      //     SweetAlertService.warning(
      //       "Warn",
      //       t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
      //     );
      //     return;
      //   }

      //   if (!this.selectedLoc.ParentLoc) {
      //     SweetAlertService.warning(
      //       "Warn",
      //       t.t(dictEnum.LBL_ParentLoc) + t.t(dictEnum.WARN_IsRequired)
      //     );
      //     return;
      //   }

      //   if (!this.selectedLoc.Addr) {
      //     SweetAlertService.warning(
      //       "Warn",
      //       t.t(dictEnum.LBL_Address) + t.t(dictEnum.WARN_IsRequired)
      //     );
      //     return;
      //   }

      if (!this.selectedLoc.Area) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_District) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      if (this.mode == "new") {
        this.selectedLoc.AddBy = this.$store.getters[StoreGetter.user].UserID;
      }

      this.selectedLoc.ModifyBy = this.$store.getters[StoreGetter.user].UserID;

      const obj = {
        loc: this.selectedLoc,
      };

      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.CFM_Save),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm),
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const response =
          this.mode == "new"
            ? await LocationService.addLocation(obj)
            : await LocationService.updateLocation(obj);
        if (response.data.IsSuccess) {
          this.getLocationList();
          this.getLocation(this.selectedLoc);
          SweetAlertService.success("Success", response.data.Message);
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    async deleteLocation() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.WARN_Delete)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm),
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const obj = {
          loc: {
            LocCode: this.selectedLoc.LocCode,
          },
        };

        const response = await LocationService.deleteLocation(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
          this.getLocationList();
          this.selectedLoc = new Location();
          this.mode = "new";
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },
  },

  mounted() {
    this.assignRights();
    this.getDistrictList();
    this.getLocationList();
  },
};
</script>
<style scoped lang="scss">
.inputRow {
  padding-top: 10px;
}

.mx-datepicker {
  position: relative;
  display: inline-block;
  width: 122px;
  color: #73879c;
  font: 14px/1.5 "Helvetica Neue", Helvetica, Arial, "Microsoft Yahei",
    sans-serif;
}

.pick-panel-date {
  /* width: 200px !important;
    display: block;
    margin: 14px -55px !important; */
  padding: 0;
}

.pick-panel {
  width: 315px !important;
}

.radio input[type="radio"] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
  width: 18px;
  height: 18px;
}

.checkbox input[type="checkbox"] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
  width: 18px;
  height: 18px;
  margin-top: inherit;
}

div#event table tr th + th + th {
  width: 100px;
}

.mx-input-append .mx-calendar-icon {
  background-image: url();
  background-position: 50%;
  background-repeat: no-repeat;
}

input#Overseals,
input#Local {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
  width: 20px !important;
  height: 24px !important;
}

> .b-form-time-control button {
  padding: 0 !important;
}

> .bi-circle-fill {
  height: 0.5em;
  width: 0.5em;
}

> .selected-date {
  max-width: 100% !important;
}

> .VuePagination__pagination {
  margin: 0px;
}

> .VuePagination__count {
  display: none;
}

> .v-treeview-node__root {
  min-height: 25px;
  cursor: pointer;
}

.overflow-y-auto {
  overflow-y: auto;
}

.treeview-height {
  height: calc(100% - 28px);
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
  > .col,
  > [class*="col-"] {
    padding-right: 0;
    padding-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/S050000-MM/S050800-Location.vue